module.exports = ".static-footer{position:auto;bottom:0px;width:100%;margin-top:20px}\n"